// extracted by mini-css-extract-plugin
module.exports = {"drawingArea":"Drawing_drawingArea__j0JI0","canvas":"Drawing_canvas__3n_NU"};